import { render, staticRenderFns } from "./POSModule.vue?vue&type=template&id=9029740e"
import script from "./POSModule.vue?vue&type=script&lang=js"
export * from "./POSModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports